import React, { useState, useEffect } from 'react';

const Page = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('https://www.thenext-level.org/wp/wp-json/wp/v2/pages');
      const data = await response.json();
      setPages(data);
    }  
    fetchData();
  }, []);
  const currentPage = window. location;
  const current = currentPage.pathname.split('/')[1];
  return (
    
    <div className={current}>
      {pages.map((page, index) => {
        if (page.title.rendered.toLowerCase() === current) {
          return <div dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div>
        }
      })}
    </div>    
  );
}

export default Page;